import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class FirGiltiQbaiService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveExternalQuarterAmounts(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any,
    ssoId = ''
  ): Observable<any> {
    if (!data?.rowData || !data?.col_id) return of({ callSuccess: '0', errorMessage: 'Invalid payload' });
    if (data.col_id === 'DUAL_USER_RATIO_OVERRIDE') {
      const v = parseFloat(data?.rowData?.[data.col_id]);
      if (!Number.isNaN(v) && (v < 0 || v > 1)) {
        return of({ callSuccess: '0', errorMessage: 'Dual User Ratio Override value should be between 0 and 1.' });
      }
    }
    const jsonObj = [{
      tax_year: data.rowData.TAX_YEAR,
      leid: data.rowData.LEID,
      cdr_no: data.rowData.CDR_NO,
      me_code: data.rowData.ME_CODE,
      curr: data.rowData.CURR,
      reporting_period: data.rowData.REPORTING_PERIOD,
      col_type: data.col_id,
      col_value: data.rowData[data.col_id],
      combination_key: data.rowData.COMBINATION_KEY
    }];
    const jsonSettings = [{ tax_year: filterParams?.tax_year, sso_id: ssoId, screen_key: globalService?.globalParams?.screen_key }];
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonObj: JSON.stringify(jsonObj),
      jsonSettings: JSON.stringify(jsonSettings),
      object_id: data.rowData.object_id,
      sso_id: ssoId,
      process_name: 'saveQBAIManualData'
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=6l3d6u`,
      params,
      globalService,
      filterParams
    );
  }

  saveqbaiExternalAmts(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    if (!data?.rowData || !data?.colData?.map) return of({ callSuccess: '0', errorMessage: 'Invalid payload' });
    const colType = data.colData.map;
    const colVal = colType === 'EXT_SOURCE' ? 0 : data.rowData[colType];
    if (colType === 'DUAL_USER_RATIO_OVERRIDE' && (colVal < 0 || colVal > 1)) {
      return of({ callSuccess: '0', errorMessage: 'The dual user ratio override should be between 0 and 1.' });
    }
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      object_id: data.rowData.object_id,
      leid: data.rowData.LEID,
      cdr_no: data.rowData.CDR_NO,
      reporting_period: data.rowData.REPORTING_PERIOD,
      bsla_code: data.rowData.BSLA_CODE,
      reporting_curr: data.rowData.REPORTING_CURR,
      col_type: colType,
      col_val: colVal,
      source_type: data.rowData.EXT_SOURCE,
      is_issue_key_enabled: 'N'
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=r1bt42`,
      params,
      globalService,
      filterParams
    );
  }
}
